// extracted by mini-css-extract-plugin
export var alertIcon = "_s2-0";